import { saveToSessionStorage, fetchFromSessionStorage, removeFromSessionStorage } from '../utils/browserStorage'

export default {
  saveToSessionStorage,
  fetchFromSessionStorage,
  removeFromSessionStorage
}
